import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { SORTS } from "../../lib/filters";

export const SortSelect = ({ value, onChange }) => (
  <div className="flex items-center gap-3">
    <span className="hidden sm:inline text-xs uppercase tracking-[0.16em] text-taupe">
      Sort
    </span>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger
        data-testid="sort-select"
        className="h-11 w-[190px] rounded-full border-beige bg-ivory text-sm text-charcoal focus:ring-charcoal shadow-none"
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-ivory border-beige rounded-sm">
        {SORTS.map((s) => (
          <SelectItem
            key={s.v}
            value={s.v}
            data-testid={`sort-option-${s.v}`}
            className="text-sm text-charcoal focus:bg-stone"
          >
            {s.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);
